import React, { ComponentProps } from 'react'
import { Field } from 'react-final-form'

import { FieldValidator } from 'final-form'
import Utils from 'Utils'

import Input from './Input'

type Props = ComponentProps<typeof Input> & {
  checkErrorIfDirty?: boolean
  compact?: boolean
  defaultValue?: string
  displayError?: boolean
  name: string
  validate?: FieldValidator<string>
}

function InputField({
  checkErrorIfDirty,
  compact,
  displayError,
  name,
  validate,
  caption,
  defaultValue,
  ...rest
}: Props) {
  return (
    <Field<string> defaultValue={defaultValue} name={name} validate={validate}>
      {({ input: { value, onChange: handleChange }, meta }) => {
        const { hasError, error } = Utils.Form.hasError(meta, checkErrorIfDirty)

        return (
          <Input
            {...rest}
            caption={(displayError && error) || caption}
            compact={compact}
            danger={hasError}
            value={value}
            onChange={handleChange}
          />
        )
      }}
    </Field>
  )
}

export default InputField
